import { Box } from '@chakra-ui/react';
import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { routes } from '../../../constants/routes';
import { useCmsPage } from '../../cms/hooks/useCmsPage';
import { defaultPageTypes, useCmsPagesTopMenu } from '../../cms/hooks/useCmsPagesMenu';
import ErrorInfo from '../../core/components/Error/Info/ErrorInfo';
import DefaultLayout from '../../core/components/Layouts/Default/DefaultLayout';
import { pageContentLoader } from '../../core/components/Loader/Content/ContentLoader';
import Meta from '../../core/components/Meta/Meta';
import { getUrlWithPath } from '../../core/utils/url';

const HomePage = (): ReactElement | null => {
  const { t } = useTranslation();
  const { isLoading, meta, page, ui, headerProps } = useCmsPage('home');
  const { items } = useCmsPagesTopMenu(defaultPageTypes);
  const hProps = useMemo(
    () => ({ ...headerProps, defaultItems: false, menuItems: items }),
    [headerProps, items],
  );
  return (
    <DefaultLayout headerProps={hProps}>
      <Meta {...meta}>
        <link rel="canonical" href={getUrlWithPath()?.replace(routes.HOME_EXPLICIT, '')} />
      </Meta>
      {isLoading ? (
        pageContentLoader
      ) : page ? (
        ui
      ) : (
        <Box py={[12, 20, 24, 28]}>
          <ErrorInfo
            title={t('error.defaultTitle')}
            description={t('error.defaultDescription')}
            homeButton={false}
          />
        </Box>
      )}
    </DefaultLayout>
  );
};
export default HomePage;
